import { motion } from "framer-motion";
import AnimatedSection from "./AnimatedSection";
import Icon from "./Icon";

const steps = [
  {
    icon: "post_add",
    iconBg: "bg-primary-container/10",
    iconColor: "text-primary",
    title: "Post a Favour",
    description:
      "Describe what you need. From dog walking to furniture assembly. Set your price and timeline.",
  },
  {
    icon: "handshake",
    iconBg: "bg-secondary-container/20",
    iconColor: "text-secondary",
    title: "Match & Contract",
    description:
      "Review nearby SOLID-verified helpers. When you accept, a smart micro-contract is instantly generated.",
  },
  {
    icon: "task_alt",
    iconBg: "bg-tertiary-container/10",
    iconColor: "text-tertiary",
    title: "Pristine Completion",
    description:
      "Task finished. Payment released. Reputation points awarded. Experience the satisfaction of a job well done.",
  },
];

function HowItWorks() {
  return (
    <section className="py-32 px-8 bg-surface scroll-mt-20" id="how-it-works">
      <div className="max-w-7xl mx-auto text-center mb-20">
        <AnimatedSection>
          <h2 className="font-headline text-4xl md:text-5xl font-extrabold tracking-tight mb-6">
            Simple. Transparent. Solid.
          </h2>
        </AnimatedSection>
        <AnimatedSection delay={0.1}>
          <p className="text-on-surface-variant text-lg max-w-2xl mx-auto">
            Three steps to getting anything done within your community.
          </p>
        </AnimatedSection>
      </div>

      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
        {steps.map((step, i) => (
          <motion.div
            key={step.title}
            className="group p-8 rounded-xl bg-surface-container-lowest shadow-sm hover:shadow-xl transition-all duration-500 border border-transparent hover:border-primary-container/20"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: i * 0.15 }}
          >
            <div
              className={`w-16 h-16 rounded-2xl ${step.iconBg} flex items-center justify-center ${step.iconColor} mb-8 group-hover:scale-110 transition-transform`}
            >
              <Icon name={step.icon} className="text-3xl" />
            </div>
            <h3 className="font-headline text-2xl font-bold mb-4">{step.title}</h3>
            <p className="text-on-surface-variant leading-relaxed">{step.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default HowItWorks;
